import { render, staticRenderFns } from "./approvalForm.vue?vue&type=template&id=2ea4e454&scoped=true"
import script from "./approvalForm.vue?vue&type=script&lang=js"
export * from "./approvalForm.vue?vue&type=script&lang=js"
import style0 from "./approvalForm.vue?vue&type=style&index=0&id=2ea4e454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4e454",
  null
  
)

export default component.exports